/**
 * AJAX functions to fetch posts
 *
 */


jQuery( document ).ready( function ( $ ) {
	const loadPostsBtn = $( '.js-load-more-posts' );


	/*
	* Function that fetches all recent events
	*
	*/
	loadPostsBtn.on( 'click', function ( e ) {

		/* Prevent Default Behaviour */
		e.preventDefault();
		const apiUrl           = postsLocalizedArray.admin_ajax;
		const viewMoreText     = $( this ).data( 'view-more' );
		const noMoreText       = $( this ).data( 'no-more' );
		let postsOffset        = $( this ).data( 'offset' );
		const order            = $( this ).data( 'order' );
		const orderBy          = $( this ).data( 'order-by' );
		const postsWrapperId   = $( this ).data( 'id' ) ? '#' + $( this ).data( 'id' ) : '#posts-wrapper';
		const postsWrapper     = $( postsWrapperId );
		const postsPerPage     = $( this ).data( 'per-page' );
		const postType         = $( this ).data( 'post-type' );
		const taxonomy         = $( this ).data( 'taxonomy' );
		const taxonomyTerm     = $( this ).data( 'taxonomy-term' );
		const componentPath    = $( this ).data( 'component-path' );
		const componentName    = $( this ).data( 'component-name' );
		const componentOptions = $( this ).data( 'component-options' );
		const $this            = $( this );

		console.log("componentOptions: ", componentOptions);

		/** Ajax Call */
		$.ajax( {
			cache: false,
			timeout: 8000,
			url: apiUrl,
			type: 'POST',
			// eslint-disable-next-line camelcase
			data: ({
				action: 'load_more_posts',
				// eslint-disable-next-line camelcase
				posts_per_page: postsPerPage,
				// eslint-disable-next-line camelcase
				posts_offset: postsOffset,
				order: order,
				// eslint-disable-next-line camelcase
				order_by: orderBy,
				// eslint-disable-next-line camelcase
				post_type: postType,
				taxonomy,
				// eslint-disable-next-line camelcase
				taxonomy_term: taxonomyTerm,
				// eslint-disable-next-line camelcase
				component_path: componentPath,
				// eslint-disable-next-line camelcase
				component_name: componentName,
				// eslint-disable-next-line camelcase
				component_options: componentOptions
			}),

			beforeSend: function () {
				$this.text( 'Loading...' );
			},

			success: function ( data, textStatus, jqXHR ) {
				$this.text( viewMoreText );

				const ajaxResponse = $( data );

				if ( 0 >= ajaxResponse.length ) {

					$this.text( noMoreText );
					$this.attr( 'disabled', true );
					$this.hide();
				}

				postsWrapper.append( ajaxResponse );

				$this.data( 'offset', postsOffset + postsPerPage );
			},

			error: function ( jqXHR, textStatus, errorThrown ) {
				console.log( 'The following error occured: ' + textStatus, errorThrown );
			},

			complete: function ( jqXHR, textStatus ) {

			}

		} );
	} );

} );
